import { MainSubTitle, MainTitle } from "../../Title";
import { Box, Container, Grid } from "@mui/material";
import { GlanceInfoBox, GlanceWrapper } from "styles/jss/Home.styles";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import NextImage from "../../NextImage";
import Counter from "./Counter";

export default function GlanceSection({ glance }) {
  const { locale } = useRouter();
  const { t } = useTranslation(["common"]);
  const { description, items } = glance;

  const render_plusIcon = (type, children) => {
    return (
      <>
        {type === "plus" && locale === "en" ? (
          <i className="valueType">+</i>
        ) : null}

        {children}

        {type === "plus" && locale === "fa" ? (
          <i className="valueType">+</i>
        ) : null}
      </>
    );
  };

  const render_otherIcon = type => {
    return (
      <>
        <i className="valueType">
          {type === "percentage"
            ? "%"
            : type === "ton"
            ? t("ton")
            : type === "Mton"
            ? t("Mton")
            : null}
        </i>
      </>
    );
  };
  return (
    <GlanceWrapper>
      <Container>
        <MainTitle textAlign={"center"}>
          {t("company-at-glance.glance-title")}
        </MainTitle>
        {!!description && (
          <MainSubTitle className="section-subtitle">
            {description}
          </MainSubTitle>
        )}
        <Box sx={{ marginTop: "100px" }}>
          <Grid
            container
            columnSpacing={{ sm: 3 }}
            rowSpacing={{ xs: 12.5, lg: 0 }}
          >
            {items.map((item, index) => (
              <Grid item xs={12} sm={6} lg={4} key={index}>
                <GlanceInfoBox>
                  <div className="valueWrapper">
                    <i className="icon">
                      <NextImage
                        src={item.icon?.data?.attributes?.url}
                        alt={item.title}
                        layout={"responsive"}
                        width={70}
                        height={70}
                      />
                    </i>
                    <span className="valueContainer">
                      {render_plusIcon(
                        item.value_type,
                        <Counter start={0} end={item.value} />,
                        
                      )}{" "}
                      {render_otherIcon(item.value_type)}
                    </span>
                  </div>

                  <h4 className="title">{item.title}</h4>
                  <p className="text">{item.subtitle}</p>
                </GlanceInfoBox>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </GlanceWrapper>
  );
}
